import '../common';

import(/* webpackChunkName: "contactUsModal" */ '../contact_us_modal').then(module =>
  module.contactUsModal(),
);
import(/* webpackChunkName: "Accordion" */ '../accordion').then(module =>
  new module.Accordion().mount(),
);
import(/* webpackChunkName: "AddressSearchForm" */ '../address_search_form').then(module =>
  new module.AddressSearchForm().mount(),
);
import(/* webpackChunkName: "PusherSidebar" */ '../pusher_sidebar').then(module =>
  new module.PusherSidebar().mount(),
);
import(/* webpackChunkName: "CalculateReward" */ '../calculators/calculate_reward').then(module =>
  new module.CalculateReward().mount(),
);

if (document.getElementById('promo_auto_applied_banner')) {
  import(/* webpackChunkName: "promoAutoAppliedManager" */ 'promo_auto_applied_manager').then(
    module => {
      module.promoAutoAppliedManager();
    },
  );
}
